import { CommonModule } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core'
import { ButtonComponent } from '../button/button.component'
import { IconComponent } from '../icon/icon.component'
import { TypographyComponent } from '../typography/typography.component'
import { IconTypes, IconValuesType } from '../icon/icon.component.types'

@Component({
  selector: 'hyperkit-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent, IconComponent, TypographyComponent], // Import CommonModule for directives like ngClass
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {
  @Input() public type:
    | 'default'
    | 'success'
    | 'warning'
    | 'error'
    | 'info' = 'default'
  @Input() public text?: string
  @Input() public closable = true
  @Input() public actionText?: string
  @Input() public justify: 'between' | 'center' = 'between'
  @Input() public showIcon = true

  @Output() public bannerClose = new EventEmitter<MouseEvent>()
  @Output() public action = new EventEmitter<MouseEvent>()

  public getIconClass(): IconValuesType {
    switch (this.type) {
      case 'success':
        return IconTypes.Check
      case 'warning':
        return IconTypes.AlertOctagon
      case 'error':
        return IconTypes.XOctagon
      case 'info':
        return IconTypes.Info
      default:
        return IconTypes.Info
    }
  }

  public onClose(): void {
    this.bannerClose.emit() // Emit event when close button is clicked
  }

  public onAction(): void {
    this.action.emit() // Emit event when action button is clicked
  }
}
